import { createAction } from 'redux-actions';
import HealthQuestionnaire from '../utils/HealthQuestionnaire/HealthQuestionnaire'

export const editHealthQuestionnaire = createAction('EDIT_HEALTH_QUESTIONNAIRE', HealthQuestionnaire.edit);
export const setHealthQuestionnaire = createAction('SET_HEALTH_QUESTIONNAIRE')
export const updateHealthQuestionnaire = createAction('UPDATE_HEALTH_QUESTIONNAIRE',HealthQuestionnaire.update)
// export const logoutAction = createAction('UPDATE_APPLICATION_FOR_ADMISSION', AuthDevise.logout);


// WEBPACK FOOTER //
// ./src/dashboards_redux/actions/HealthQuestionnaireAction.jsx